import { useState } from "react";
import api from "../../utils/api";
import "./comment.css";

export default function CommentInput({ videoId, user, onSuccess }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!text.trim()) return;

    try {
      setLoading(true);

      await api.post("/client/videoComment/createComment", {
        userId: user._id,
        videoId,
        commentText: text,
      });

      setText("");
      onSuccess();
    } catch {
      // silent fail (same as before)
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="comment-input-wrapper">

      <textarea
        value={text}
        onChange={(e) => setText(e.target.value)}
        placeholder={`Write a comment...`}
        rows={2}
        className="comment-textarea"
      />

      <button
        onClick={submit}
        disabled={loading}
        className="comment-submit-btn"
      >
        {loading ? "Posting..." : "Post"}
      </button>

    </div>
  );
}
